// removed by extract-text-webpack-plugin
module.exports = {"tiling-container":"news-tiling-container","banner-large":"news-banner-large","banner-small":"news-banner-small","banner-small-container":"news-banner-small-container","horizontal-container":"news-horizontal-container","banner-horizontal":"news-banner-horizontal","hover-effects":"news-hover-effects"};


//////////////////
// WEBPACK FOOTER
// ./apps/ingame.companyofheroes.com/src/styles/news.less
// module id = 25
// module chunks = 0